import { Box, Button, Card, Icon, Tag, Text } from '@zillow/constellation-10';
import { IconDoorOpenFilled } from '@zillow/constellation-icons';

export type UnitItemProps = {
  unitName: string;
  unitType: string;
  status: string;
  onEditClick: () => void;
};

const UnitItem = ({ unitName, unitType, status, onEditClick }: UnitItemProps) => {
  return (
    <Card
      data-testid="UnitItem"
      tone="neutral"
      elevated={false}
      css={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '200',
        width: '100%',
        paddingBlock: '300',
        paddingInline: '400',
      }}
    >
      <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '300', minWidth: 0, flex: 1 }}>
        <Box css={{ flexShrink: 0 }} aria-hidden={true}>
          <Icon size="lg" css={{ color: 'icon.neutral' }} render={<IconDoorOpenFilled />} />
        </Box>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '25', minWidth: 0 }}>
          <Text textStyle="body-bold" css={{ color: 'text.default' }}>
            {unitName}
          </Text>
          <Text textStyle="body-sm" css={{ color: 'text.subtle' }}>
            {unitType}
          </Text>
        </Box>
      </Box>

      <Box
        css={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '200',
          flexShrink: 0,
        }}
      >
        <Tag size="sm" tone="gray">
          {status}
        </Tag>
        <Button type="button" tone="brand" emphasis="filled" size="sm" onClick={onEditClick}>
          Edit
        </Button>
      </Box>
    </Card>
  );
};

export default UnitItem;
